import React from "react";
import {
  Company1Img,
  Company2Img,
  Company4Img,
  Company5Img,
  Company7Img,
  Company8Img,
  Company9Img,
} from "../../assets";
import moglix from "../../assets/moglix.png";
import renovateindia from "../../assets/renovateindia.png";
import wiredsoftsolution from "../../assets/wiredsoftsolution.png";
import jubilee from "../../assets/jubilee.jpeg"
import Company6Img from "../../assets/afclogo.png"
import  Company3Img  from "../../assets/pine-labs.png";
const Companies = () => {
  const companyRows = [
    [
      { src: Company1Img, alt: "Company 1" },
      { src: Company2Img, alt: "Company 2" },
      { src: Company3Img, alt: "Company 3" },
      { src: Company4Img, alt: "Company 4" },
      { src: Company5Img, alt: "Company 5" },
      { src: Company6Img, alt: "Company 6" },
      { src: Company7Img, alt: "Company 7" },
      { src: Company8Img, alt: "Company 8" },
      { src: Company9Img, alt: "Company 9" },
      { src: moglix, alt: "Moglix" },
      { src: renovateindia, alt: "Renovate India" },
      { src: wiredsoftsolution, alt: "Wired Soft Solution" },
      { src: jubilee, alt: "jubilee" },
      {
        src: "https://ik.imagekit.io/bhavishya/web-final/companies/logo-full-black.svg",
        alt: "Devotica",
      },
    ],
  ];

  const CompanyImage = ({ src, alt }) => (
    <div className="flex items-center justify-center p-2 sm:p-3 md:p-4">
      <img
        src={src}
        alt={alt}
        className="h-16 sm:h-20 md:h-24 w-auto object-contain transition-transform duration-300 hover:scale-110"
      />
    </div>
  );

  return (
    <section className="bg-primaryBg px-4 sm:px-6 md:px-8 lg:px-12 py-8 md:py-12 lg:py-16 xl:py-20">
      <div className="max-w-7xl mx-auto space-y-6 md:space-y-8 lg:space-y-12">
        {/* Header Section */}
        <div className="text-center space-y-2 sm:space-y-3 md:space-y-4">
          <h2 className="font-Cheri text-borderRed text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl leading-tight px-4">
            Changing the world is a team effort
          </h2>
          <p className="font-Poppins text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-700 max-w-3xl mx-auto px-4">
            Our supporters believed in what we do, and most importantly, they cared.
          </p>
        </div>

        {/* Companies Grid */}
        <div className="space-y-2 sm:space-y-3 md:space-y-4">
          {companyRows.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-2 sm:gap-3 md:gap-4 lg:gap-6"
            >
              {row.map((company, colIndex) => (
                <div
                  key={`${rowIndex}-${colIndex}`}
                  className="flex items-center justify-center bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 aspect-square"
                >
                  <CompanyImage src={company.src} alt={company.alt} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Companies;